import React, { useMemo } from 'react';

import { Flex } from 'antd';
import { DatabaseOutlined } from '@ant-design/icons';
import { WidgetStatistic } from 'src/pages/dashboard/styles';
import { FaCaretDown, FaCaretRight, FaCaretUp } from 'react-icons/fa';
import useOccurrences from 'src/pages/dashboard/contexts/useOccurrences';
import {
	CardData,
	CardTitle,
	IconArea
} from 'src/pages/dashboard/components/cards/styles';

export default function TotalOpenedOccurrences() {
	const { occurrences, lastPeriodOccurrences, } = useOccurrences();

	const data = useMemo(() => {
		const openOccurrences = occurrences.filter(occ => !occ.is_recovery);
		const closedOccurrences = occurrences.filter(occ => occ.is_recovery);
		const totalOpen = openOccurrences.length - closedOccurrences.length;
		return totalOpen < 0 ? 0 : totalOpen;
	}, [ occurrences, ]);

	const statistic = useMemo(() => {
		const openOccurrences = occurrences.filter(occ => !occ.is_recovery);
		const closedOccurrences = occurrences.filter(occ => occ.is_recovery);
		const totalOpen = openOccurrences.length - closedOccurrences.length;

		const lastPeriodOpenOccurrences = lastPeriodOccurrences.filter(occ => !occ.is_recovery);
		const lastPeriodClosedOccurrences = lastPeriodOccurrences.filter(occ => occ.is_recovery);
		const lastPeriodTotalOpen = lastPeriodOpenOccurrences.length - lastPeriodClosedOccurrences.length;

		if (lastPeriodTotalOpen === 0) return 100;

		return ((totalOpen - lastPeriodTotalOpen) / lastPeriodTotalOpen) * 100;
	}, [ lastPeriodOccurrences.length, occurrences.length, ]);

	return (
		<Flex
			gap={16}
			justify='space-between'
			style={{ width: '100%', }}
		>
			<Flex vertical gap={4}>
				<CardTitle>
					Total de ocorrências abertas:
				</CardTitle>
				<CardData>
					<span>{data}</span>
					<WidgetStatistic
						style={{
							color: statistic > 0
								? '#FF0000' : statistic < 0
									? '#52C41A' : 'inherit',
							borderColor: statistic > 0
								? '#FF0000' : statistic < 0
									? '#52C41A' : 'inherit',
						}}
					>
						{
							statistic > 0
								? <FaCaretUp /> : statistic < 0
									? <FaCaretDown /> : <FaCaretRight />
						}
						{Math.abs(statistic)?.toFixed(2)}
					</WidgetStatistic>
				</CardData>
			</Flex>
			<IconArea>
				<DatabaseOutlined style={{ fontSize: 24, color: '#fff', }} />
			</IconArea>
		</Flex>
	);
}
